// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2OmqT","signatureBlock":"Footer_signatureBlock__1Hjd5","signature":"Footer_signature__3W6hB"};